import styled from "styled-components";
import { colors } from "constants/colors";

export const StyledCustomizedRadio = styled.div<{ checked: boolean; disabled?: boolean }>`
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${colors.signInBorderColor};
  margin: 0 10px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  ${({ checked }) =>
    checked &&
    `
    ::before {
      content: '';
      position: absolute;
      left: 3px;
      top: 3px;
      width: 10px;
      height: 10px;
      background-color: ${colors.optionBackground};
      border-radius: 50%;
    }
  `}
`;